import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AppService } from '../../services/app.service';
import { delay, finalize } from 'rxjs/operators';
import { DiplomaSupplementService } from '../../services/diploma-supplement.service';
import { IDiplomaSupplementContactPerson, IDiplomaSupplementListModel } from '../../models/DiplomaSupplement';

@Component({
    selector: 'app-diploma-supplement-change-contact-person',
    templateUrl: './change-contact-person.component.html'
})
export class DiplomaSupplementChangeContactPersonComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: DiplomaSupplementService,
        private activeModal: NgbActiveModal
    ) { }

    @Input() selected: number[] = [];
    @Input() filtered: {
        program: string,
        semester: string,
        contactPerson: string,
        search: string,
        total: number
    };

    program: string;
    semester: string;
    contactPersonFrom: string;
    contactPersonTo: string;

    programs: string[] = [];
    semesters: string[] = [];
    contactPersonsFrom: string[] = [];
    contactPersonsTo: string[] = [];

    items: IDiplomaSupplementListModel[] = [];
    contactPersons: IDiplomaSupplementContactPerson[] = [];

    mode: 'filtered' | 'selected';
    hasItems: boolean;

    isSaving: boolean;

    readonly contactPersonDisplayFn = (option: IDiplomaSupplementContactPerson) => `${option.Name} ${option.Surname} (${option.Upn})`;

    @ViewChild('form', { static: true }) private form: NgForm;

    ngOnInit() {
        this.hasItems = false;

        if (this.selected?.length) {
            this.mode = 'selected';
            this.hasItems = true;
        } else if (this.filtered?.total) {
            this.mode = 'filtered';
            this.hasItems = true;
        }

        if (this.hasItems) {
            this.app.addLoading(this.service.getContactPersons()).subscribe(data => {
                this.contactPersons = data;
            });
        }
    }

    fetch() {
        this.app.addLoading(this.service.get({
            filter: {
                contactPerson: this.contactPersonFrom,
                program: this.program,
                semester: this.semester
            }
        })).subscribe(data => {
            this.items = data.items;
        });
    }

    save() {
        const filtered = this.mode === 'filtered';

        const criteria = {
            contactPerson: filtered ? this.filtered.contactPerson : undefined,
            id: filtered ? undefined : this.selected,
            program: filtered ? this.filtered.program : undefined,
            semester: filtered ? this.filtered.semester : undefined,
            search: filtered ? this.filtered.search : undefined
        };

        this.isSaving = true;

        this.service.setContactPerson(criteria, this.contactPersonTo).pipe(delay(500), finalize(() => this.isSaving = false)).subscribe(() => {
            this.activeModal.close();
        });
    }

    cancel() {
        this.activeModal.dismiss();
    }
}
